import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { viewerInterface } from "../../viewer.interface";
import { VIEWER_CONSTANT } from "../constant/viewer.constant";
import { PAGE_CONFIG } from "../../../common/constant/pageconfig.constant";

@Injectable({
  providedIn: "root",
})
export class ViewerService {
  constructor(private httpClient: HttpClient) {}

  //soft delete
  public updateData(viewerData: viewerInterface) {
    let viewerId = viewerData.id;
    return this.httpClient.put(
      `${VIEWER_CONSTANT.VIEWER_DATA}/${viewerId}`,
      viewerData
    );
  }

  //bithday count
  getBirthdayCountTotal() {
    return this.httpClient.get(VIEWER_CONSTANT.BIRTHDAY_COUNT);
  }

  //office count
  public getOfficeCount() {
    return this.httpClient.get(VIEWER_CONSTANT.OFFICE_COUNT);
  }

  public getOfficeNewlyAddedCount() {
    return this.httpClient.get(VIEWER_CONSTANT.OFFICE_COUNT_NEW);
  }
  //karyakarta count
  public getKaryakartaCount() {
    return this.httpClient.get(VIEWER_CONSTANT.KARYAKARTA_COUNT);
  }

  public getKaryakartaInactiveCount() {
    return this.httpClient.get(VIEWER_CONSTANT.KARYAKARTA_INACTIVE);
  }

  //document count
  public getRepoCount() {
    return this.httpClient.get(VIEWER_CONSTANT.REPO_COUNT);
  }

  public getRepoNewlyAddedCount() {
    return this.httpClient.get(VIEWER_CONSTANT.REPO_COUNT_NEW);
  }

  //keosks count

  public getKeosksCount() {
    return this.httpClient.get(VIEWER_CONSTANT.KIOSK_COUNT);
  }

  public getKeosksNotWorkingCount() {
    return this.httpClient.get(VIEWER_CONSTANT.KIOSK_NOT_WORKING_COUNT);
  }

  public createViewerData(viewerData: viewerInterface) {
    return this.httpClient.post(VIEWER_CONSTANT.VIEWER_DATA, viewerData);
  }

  public getViewerData() {
    return this.httpClient.get(VIEWER_CONSTANT.VIEWER_List);
  }

  public getViewerEdit(viewerId: any) {
    return this.httpClient.get(`${VIEWER_CONSTANT.VIEWER_DATA}/${viewerId}`);
  }

  public updateViewerData(viewerData: viewerInterface) {
    let viewerId = viewerData.id;
    return this.httpClient.put(
      `${VIEWER_CONSTANT.VIEWER_DATA}/${viewerId}`,
      viewerData
    );
  }

  deleteVidewer(viewerId) {
    return this.httpClient.delete(`${VIEWER_CONSTANT.VIEWER_DATA}/${viewerId}`);
  }

  totalCount() {
    return this.httpClient.get(`${VIEWER_CONSTANT.TOTAL_COUNT}`);
  }

  public getCast() {
    return this.httpClient.get(`${VIEWER_CONSTANT.CAST}`);
  }

  public userCheck(obj) {
    return this.httpClient.post(`${VIEWER_CONSTANT.USER_CHECK}`, obj);
  }

  public getPageConfig() {
    return this.httpClient.get(PAGE_CONFIG.Viewer_Page);
  }
  public restoreRecord(rowData: any) {
    return this.httpClient.patch(`/user/restore/${rowData.id}`, {});
  }

}
